import { z } from "zod";

import { FilterFieldConfig } from "@/modules/common/filters";
import {
  MANAGER_USER_ROLE_OPTIONS,
  MANAGER_USER_STATUS_OPTIONS,
  ManagerUserRole,
  ManagerUserStatus,
} from "@/modules/common/types/ManagerUsers.enum";

export const MANAGER_USER_FILTER_FIELDS: FilterFieldConfig[] = [
  {
    key: "search",
    label: "Pesquisar",
    type: "text",
    placement: "inline",
    schema: z.string(),
  },
  {
    key: "role",
    label: "Perfil",
    type: "select",
    placement: "both",
    schema: z.coerce.number().pipe(z.enum(ManagerUserRole)),
    options: MANAGER_USER_ROLE_OPTIONS,
  },
  {
    key: "status",
    label: "Status",
    type: "select",
    placement: "both",
    schema: z.coerce.number().pipe(z.enum(ManagerUserStatus)),
    options: MANAGER_USER_STATUS_OPTIONS,
  },
];
